import { useAuthStore } from '@bemor/web-kit';
import {
    ActivityPanel,
    Card,
    CardContent,
    CardHeader,
    CardTitle,
} from '@bemor/web-kit/ui';

import { P } from '@/lib/permissions';
import { useMe, useStaffDirectory, whoName } from '@/lib/staff';

/**
 * BM-46 §2.9: what happened to a record, from the audit log (who, when, old → new), on its detail page; only for
 * staff who may read the audit log.
 */
export function ActivityCard({ entity, id }: { entity: string; id: string }) {
    const can = useAuthStore((s) => s.can);
    const me = useMe();
    const directory = useStaffDirectory();
    if (!can(P.auditRead)) return null;
    return (
        <Card data-testid="activity">
            <CardHeader>
                <CardTitle className="text-sm font-medium">Activity</CardTitle>
            </CardHeader>
            <CardContent>
                <ActivityPanel
                    entity={entity}
                    id={id}
                    actorName={(actor) => whoName(actor, me, directory)}
                />
            </CardContent>
        </Card>
    );
}
